<template>
  <transition name="modal" id="product-list-dialog" v-if="showPopup">
    <DxPopup
      class="vertical-center"
      ref="productSelector"
      id="dx-dialog"
      width="100vw"
      height="100vh"
      :title="$t('common.filters')"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      :resize-enabled="true"
      :drag-enabled="false"
      @hidden="buttonCloseEvent"
    >
      <template #title>
        <div class="filter_title_template">
          <div class="left_side">
            <img src="@/assets/images/icons/arrow-back.svg" @click="goBackOneStep" />
            <span @click="goBackOneStep">{{ $t("common.back") }}</span>
          </div>
          <div class="right_side">
            <img class="close_button" src="@/assets/images/icons/dialog-close.svg" @click="buttonCloseEvent" />
          </div>
        </div>
      </template>
      <template #content>
        <div class="filters_tabs">
          <DxTabPanel
            :data-source="filterSteps"
            :loop="false"
            :selected-index="currentStep"
            :animation-enabled="true"
            :swipe-enabled="false"
            :show-nav-buttons="false"
            @selection-changed="tabSelectionChanged($event)"
          >
            <template #item="{ data: step }">
              <div>
                <div v-if="step == 1" class="filter_container" :use-native="true">
                  <ProductList
                    ref="productGridWithAdd"
                    @selectionChanged="productSelected"
                    :action-method="selectFromStock ? loadStockProductsPage : getProducts"
                    :dataColumns="productComboColumns"
                    :localDataset="stockProductList"
                    :hasError="false"
                    :allowAddNew="allowAddNew"
                    :placeholder="$t('stock_mobile.form.select_product')"
                    :filterData="filterData"
                    :transactionType="transactionType"
                  ></ProductList>
                </div>
                <div v-if="step == 2" class="filter_container" :use-native="true">
                  <div class="filter_header_container filter_header_container_product_data">
                    <div class="filter_header filter_header_product_data">{{ transactionType }} \ {{ selectedProduct?.name ?? "" }}</div>
                    <i v-if="!multipleSelection && isProductEditable" class="fa-regular fa-edit" @click="goBackOneStep"></i>
                  </div>
                  <ProductData
                    ref="productDataEdit"
                    :selectedProductList="selectedProducts"
                    :selectedProduct="selectedProduct"
                    @goForward="goForward"
                    @closeProductSelector="buttonCloseEvent"
                    :selectFromStock="selectFromStock"
                    :multipleSelection="multipleSelection"
                    :useUnitPrice="useUnitPrice"
                    :totalArea="totalArea"
                    :movementDate="movementDate"
                    :transactionType="transactionType"
                    :filterData="filterData"
                    :destWarehouses="destWarehouses"
                    :requireDestWarehouse="requireDestWarehouse"
                    :allowStockMovementOnlyInLegalEntity="allowStockMovementOnlyInLegalEntity"
                    :requiredLotForLotManagedProducts="requiredLotForLotManagedProducts"
                  >
                  </ProductData>
                </div>
                <div v-if="step == 3" class="filter_container" :use-native="true">
                  <div class="filter_header_container">
                    <div class="filter_header">{{ transactionType }} \ {{ $t("stock_mobile.form.added_products") }}</div>
                    <div class="new_item_add_button" @click="goToStep(0)" v-if="isProductEditable">
                      <i class="fas fa-plus"></i>
                    </div>
                  </div>
                  <SelectedProductList
                    :selectedProductList="selectedProducts"
                    @closeProductSelector="buttonCloseEvent"
                    @editProductData="editProductData"
                    :selectFromStock="selectFromStock"
                    :isProductEditable="isProductEditable"
                    :transactionType="transactionType"
                  >
                  </SelectedProductList>
                </div>
              </div>
            </template>
          </DxTabPanel>
          <toast-message ref="toastMessageProductSelector"></toast-message>
        </div>
      </template>
    </DxPopup>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import { DxPopup } from "devextreme-vue/popup";
import DxTabPanel from "devextreme-vue/tab-panel";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import ProductList from "./ProductList.vue";
import ProductData from "./ProductData.vue";
import SelectedProductList from "./SelectedProductList.vue";

export default {
  name: "ProductSelector",
  props: {
    showPopup: {
      type: Boolean,
      default: true,
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
    selectFromStock: {
      type: Boolean,
      default: false,
    },
    allowAddNew: {
      type: Boolean,
      default: true,
    },
    filterData: {
      type: Object,
      default: null,
    },
    multipleSelection: {
      type: Boolean,
      default: true,
    },
    useUnitPrice: {
      type: Boolean,
      default: true,
    },
    totalArea: {
      type: Number,
      default: 0,
    },
    movementDate: {
      type: String,
      default: "",
    },
    transactionType: {
      type: String,
      default: "",
    },
    destWarehouses: {
      type: Array,
      default: () => [],
    },
    requireDestWarehouse: {
      type: Boolean,
      default: false,
    },
    allowStockMovementOnlyInLegalEntity: {
      type: Boolean,
      default: false,
    },
    isProductEditable: {
      type: Boolean,
      default: true,
    },
    requiredLotForLotManagedProducts: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filterSteps: [1, 2, 3],
      currentStep: 0,
      selectedProduct: {},
      productComboColumns: this.selectFromStock
        ? [
            { dataField: "product_name_code", caption: this.$t("stock_mobile.form.product_code") },
            { dataField: "warehouse_name", caption: this.$t("common.warehouse")},
            { dataField: "warehouse_quantity_m", caption: this.$t("common.quantity"), width: "25%" },
          ]
        : [
            { dataField: "code", caption: this.$t("stock_mobile.form.code"), width: "25%" },
            { dataField: "name", caption: this.$t("common.name") },
          ],
      stockProductList: [],
      stockPager: {
        cache: [],
        nextPage: 1,
        hasMorePages: true,
        lastQueryKey: null,
      },
    };
  },
  components: {
    DxPopup,
    DxTabPanel,
    ToastMessage,
    ProductList,
    ProductData,
    SelectedProductList,
  },
  computed: {},
  watch: {
    showPopup(newVal) {
      if (newVal) {
        if (
          this.selectedProducts &&
          this.selectedProducts.length == 1 &&
          ((this.selectedProducts[0].quantity ?? 0) == 0 || !this.multipleSelection)
        ) {
          this.selectedProduct = this.selectedProducts[0];
          this.currentStep = 1;
        } else if (this.selectedProducts && this.selectedProducts.length > 0) {
          this.currentStep = 2;
        } else {
          this.currentStep = 0;
        }
        this.setTitle();
      }
    },
    "filterData.department_legal_entity_uuid": {
      handler: function () {
        this.resetStockPagerAndRefresh();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      getProducts: "smProducts/getSmProducts",
      getSmProductsFull: "smProducts/getSmProductsFull",
    }),
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.filterSteps.indexOf(this.currentItem);
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.product_reception"), true);
      } else if (this.currentStep == 1) {
        this.$emit("setTitle", this.$t("stock_mobile.form.products_list"), false);
      }
    },
    goForward() {
      this.currentStep = this.currentStep + 1;
      this.setTitle();
    },
    goBackOneStep() {
      if (this.currentStep > 0) {
        this.currentStep = this.currentStep - 1;
        this.setTitle();
      } else {
        this.buttonCloseEvent();
      }
    },
    goToStep(step) {
      this.currentStep = step;
      this.setTitle();
    },
    buttonCloseEvent() {
      this.$emit("hidden");
    },
    editProductData(productUuid) {
      const product = this.selectedProducts.find((product) => product.uuid === productUuid);
      if (product) {
        this.selectedProduct = product;
        this.goToStep(1);
      }
    },
    productSelected(selectedProduct) {
      if (selectedProduct && selectedProduct.uuid) {
        const existingProduct = this.selectedProducts.find(
          (product) =>
            product.uuid === selectedProduct.uuid ||
            (product.uuid.toString().startsWith("NEW_") &&
              selectedProduct.uuid.toString().startsWith("NEW_") &&
              product.name === selectedProduct.name)
        );

        if (existingProduct) {
          this.$refs.toastMessageProductSelector.showError(this.$t("stock_mobile.form.error_product_already_added"));
          return;
        }

        selectedProduct.measure_unit_id = selectedProduct?.measure_unit?.id ?? null;
        this.selectedProduct = { ...selectedProduct };

        this.goForward();
      }
    },
    resetStockPager() {
      this.stockPager.cache = [];
      this.stockPager.nextPage = 1;
      this.stockPager.hasMorePages = true;
      this.stockPager.lastQueryKey = null;
    },
    resetStockPagerAndRefresh() {
      if (!this.selectFromStock) {
        return;
      }

      this.resetStockPager();
      this.$nextTick(() => {
        this.$refs.productGridWithAdd?.refreshData?.();
      });
    },
    getStockQueryKey(loadOptions) {
      return JSON.stringify({
        department_legal_entity_uuid: this.filterData?.department_legal_entity_uuid ?? null,
        filter: loadOptions?.filter ?? null,
        sort: loadOptions?.sort ?? null,
      });
    },
    mapStockRows(stocks) {
      const rows = [];

      (stocks || []).forEach((stock) => {
        if (this.selectFromStock) {
          (stock.stock_list || []).forEach((stock_data) => {
            const warehouseDepartmentName = stock_data.department_name || stock_data.department?.name || "";
            const warehouseDisplayName = warehouseDepartmentName
              ? `${stock_data.warehouse_name} (${warehouseDepartmentName})`
              : stock_data.warehouse_name;

            rows.push({
              ...stock,
              product_name_code: stock.code ? stock.name + " (" + stock.code + ")" : stock.name,
              warehouse_uuid: stock_data.warehouse_uuid,
              warehouse_name: warehouseDisplayName,
              warehouse_quantity: parseFloat(stock_data.quantity),
              warehouse_quantity_m: parseFloat(stock_data.quantity) + " " + stock.measure_unit.symbol,
              warehouse_department_legal_entity_uuid: stock_data.legal_entity_uuid,
              warehouse: {
                uuid: stock_data.warehouse_uuid,
                name: warehouseDisplayName,
                quantity: parseFloat(stock_data.quantity),
                quantity_m: parseFloat(stock_data.quantity) + " " + stock.measure_unit.symbol,
                warehouse_department_legal_entity_uuid: stock_data.legal_entity_uuid,
              },
              lot_management: stock.lot_management,
              lot_items: stock_data.lot_items || [],
            });
          });
        } else {
          rows.push({
            ...stock,
            product_name_code: stock.code ? stock.name + " (" + stock.code + ")" : stock.name,
            warehouse_uuid: null,
            warehouse_name: null,
            warehouse_quantity: 0,
            warehouse_department_legal_entity_uuid: null,
            lot_management: stock.lot_management,
            lot_items: [],
          });
        }
      });

      return rows;
    },
    async loadStockProductsPage(loadOptions) {
      const take = Number(loadOptions?.take) || 30;
      const skip = Number(loadOptions?.skip) || 0;
      const pageLimit = take;

      const currentQueryKey = this.getStockQueryKey(loadOptions);
      if (this.stockPager.lastQueryKey !== currentQueryKey) {
        this.resetStockPager();
        this.stockPager.lastQueryKey = currentQueryKey;
      }

      while (this.stockPager.hasMorePages && this.stockPager.cache.length < skip + take) {
        const payload = {
          page: this.stockPager.nextPage,
          limit: pageLimit,
          has_stock: 1,
          department_legal_entity_uuid: this.filterData?.department_legal_entity_uuid ?? null,
          filter: loadOptions?.filter,
          sort: loadOptions?.sort,
        };

        const response = await this.getSmProductsFull(payload);
        const products = response?.data?.data || [];
        const pagination = response?.data?.pagination || {};

        const mappedRows = this.mapStockRows(products);
        this.stockPager.cache.push(...mappedRows);

        const totalPages = Number(pagination.total_pages || 0);
        const noMoreByCount = products.length < pageLimit;
        const noMoreByPage = totalPages > 0 && this.stockPager.nextPage >= totalPages;

        this.stockPager.hasMorePages = !(noMoreByCount || noMoreByPage);
        this.stockPager.nextPage += 1;

        if (products.length === 0) {
          break;
        }
      }

      const data = this.stockPager.cache.slice(skip, skip + take);

      return {
        data,
        totalCount: this.stockPager.hasMorePages
          ? Math.max(this.stockPager.cache.length + 1, skip + data.length + 1)
          : this.stockPager.cache.length,
      };
    },
  },
  mounted() {
    this.resetStockPagerAndRefresh();
  },
};
</script>

<style scoped>
.filter_header_container_product_data {
  display: block; /* Use block to allow width and height */
  align-items: center; /* Vertically align items */
}

.filter_header_product_data {
   display: inline; /* Ensure the text is inline */
}

.fa-edit {
  margin-left: 8px; /* Add some spacing between the text and the icon */
  cursor: pointer; /* Optional: Add a pointer cursor for the icon */
  font-size: 1.5em;
}
</style>
